/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type GetMeterUsageSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export const Family = {
  AgentSessionStorage: "agent_session_storage",
  McpBandwidth: "mcp_bandwidth",
  RiskContentScans: "risk_content_scans",
} as const;
export type Family = ClosedEnum<typeof Family>;

export type GetMeterUsageRequest = {
  family: Family;
  /**
   * Inclusive UTC midnight reporting boundary. Must be paired with to.
   */
  from?: Date | undefined;
  /**
   * Exclusive UTC midnight reporting boundary. Must be paired with from and no later than three calendar months after from, clamped to the target month's last day.
   */
  to?: Date | undefined;
  /**
   * Family-compatible reporting facet
   */
  breakdown?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetMeterUsageSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetMeterUsageSecurity$outboundSchema: z.ZodMiniType<
  GetMeterUsageSecurity$Outbound,
  GetMeterUsageSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getMeterUsageSecurityToJSON(
  getMeterUsageSecurity: GetMeterUsageSecurity,
): string {
  return JSON.stringify(
    GetMeterUsageSecurity$outboundSchema.parse(getMeterUsageSecurity),
  );
}

/** @internal */
export const Family$outboundSchema: z.ZodMiniEnum<typeof Family> = z.enum(
  Family,
);

/** @internal */
export type GetMeterUsageRequest$Outbound = {
  family: string;
  from?: string | undefined;
  to?: string | undefined;
  breakdown?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetMeterUsageRequest$outboundSchema: z.ZodMiniType<
  GetMeterUsageRequest$Outbound,
  GetMeterUsageRequest
> = z.pipe(
  z.object({
    family: Family$outboundSchema,
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    breakdown: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getMeterUsageRequestToJSON(
  getMeterUsageRequest: GetMeterUsageRequest,
): string {
  return JSON.stringify(
    GetMeterUsageRequest$outboundSchema.parse(getMeterUsageRequest),
  );
}
